import {modals} from "ducks";
import queryString from "query-string";
import React from "react";
import {connect} from "react-redux";

const ExportControls = ({dispatch, location, url, type, opts, title, message, dateFilter, async}) => {
  const beginExport = (dispatch, location) => {
    const params = {
      ...queryString.parse(location.search),
      ...(dateFilter && dateFilter.queryParams || {}),
      sub_type: type,
      opts: opts
    }

    dispatch(modals.actions.show('Downloader', {
      url: url,
      async: async === undefined ? true : async,
      message: message,
      params
    }))
  };

  return (
        <div className={'right'} style={{marginRight: '1rem'}}>
          <button onClick={() => beginExport(dispatch, location)} className='btn btn-success'>{title || "Export To CSV"}</button>
        </div>
  )
};

export default connect()(ExportControls);
